export const countryOptions = [
    { id: 'ru', name: 'Россия' },
    { id: 'kz', name: 'Казахстан' },
    { id: 'az', name: 'Азербайджан' },
    { id: 'uz', name: 'Узбекистан' },
    { id: 'am', name: 'Армения' },
    { id: 'ge', name: 'Грузия' },
    { id: 'br', name: 'Brazil' },
    { id: 'ae', name: 'UAE' },
    { id: 'il', name: 'Israel' },
    { id: 'ar', name: 'Argentina' },
    { id: 'cl', name: 'Chile' },
    { id: 'nl', name: 'Netherlands' },
    { id: 'us', name: 'USA' },
];
